import './components.scss';

const PageLayout = (props) => {
    return (
      <div className='pageLayout'>
        {props.children}
      </div>
    )
  }

  export default PageLayout;